import { render, staticRenderFns } from "./navHeader.vue?vue&type=template&id=546e80ce&scoped=true&"
import script from "./navHeader.vue?vue&type=script&lang=js&"
export * from "./navHeader.vue?vue&type=script&lang=js&"
import style0 from "./navHeader.vue?vue&type=style&index=0&id=546e80ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e80ce",
  null
  
)

export default component.exports